import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpErrorResponse,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '@environments/environment';
import { Observable, catchError, throwError } from 'rxjs';

@Injectable()
export class HttpTokenInterceptor implements HttpInterceptor {
  private readonly router: Router = inject(Router);

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    let reqClone = request;

    // Check if the request is meant for the API.
    if (request.url.indexOf(environment.api.root) === -1) {
      return next.handle(request);
    }

    const token = sessionStorage.getItem('access_token');

    console.groupCollapsed(
      `%cAPI Request URL: ${request.url}`,
      'color: orange;background:DarkOliveGreen; padding:2px;'
    );
    console.info(
      `%cBearer:\n%c${token}`,
      'color: orange; background: DarkOliveGreen; padding:2px;',
      'color: DarkOliveGreen; background: orange; padding:2px;display:block;'
    );
    console.groupEnd();

    if (token) {
      reqClone = request.clone({
        setHeaders: { Authorization: `Bearer ${token}` },
      });
    }

    return next.handle(reqClone).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          // Redirection vers la page d'erreur 401
          this.router.navigate(['/error401']);
        }
        return throwError(() => error);
      })
    );
  }
}
